import { Pipe, PipeTransform } from '@angular/core';
import { contain } from '../services/helpers';

@Pipe({
  name: 'canDisplay',
  standalone: true
})
export class CanDisplayPipe implements PipeTransform {

  transform(value: any): boolean {
    return contain(value);
  }

}
